import { Metamodel } from 'app/model/base/model';
import { BlobTypeStoreReadSettings } from './blob-type-store-read-settings';
import { FilePathMode } from 'app/registries/consts/metadata-consts';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { SharePointOnlineFileLinkedService } from 'app/model/linkedservice/sharepoint-online-file.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.sharePointOnlineFile.storeRead,
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(SharePointOnlineFileLinkedService)
    }
})

export class SharePointOnlineFileStoreReadSettings extends BlobTypeStoreReadSettings {
    public supportedFilePathMode = [
        FilePathMode.DATASET,
        FilePathMode.WILDCARD,
        FilePathMode.LIST
    ];
}
